import "./RoundsCriteria.css";
import trophyImage from "../../assets/Trophy-image.png";

function RoundsCriteria() {
  return (
    <section id="rounds-criteria" className="rounds-criteria-section">
      <div className="rounds-criteria-container">
        <div className="rounds-criteria-left">
          <div className="trophy-icon">
            <img src={trophyImage} alt="Trophy" />
          </div>
          <h2 className="rounds-criteria-title">
            ROUNDS<br />& CRITERIA
          </h2>
        </div>

        <div className="rounds-criteria-right">
          <div className="round-item">
            <div className="round-dates">19th Jan (9 AM) to 27th Jan (4PM)</div>
            <h3 className="round-title">Online Preliminaries</h3>
            <div className="round-details">
              <p>
                <strong>Qualification -</strong> 06 teams per zone (36 teams) will qualify for Zonal Finals.
              </p>
              <p>
                <strong>Format/Duration -</strong> MCQ Format
              </p>
            </div>
          </div>

          <div className="round-separator"></div>

          <div className="round-item">
            <div className="round-dates">8th Feb</div>
            <h3 className="round-title">Zonal Finals (Offline)</h3>
            <div className="round-details">
              <p>
                <strong>Duration -</strong> 60 to 90 mins
              </p>
              <p>
                <strong>Qualification -</strong> One team per zone qualify to the nationals
              </p>
            </div>
          </div>

          <div className="round-separator"></div>

          <div className="round-item">
            <div className="round-dates">9th Feb (Tentative)</div>
            <h3 className="round-title">National Finale (Offline)</h3>
            <div className="round-details">
              <p>
                <strong>Format -</strong> Offline Finale tentatively at Lucknow
              </p>
              <p>
                <strong>Duration -</strong> 60 - 90 mins
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default RoundsCriteria;
